export default class Exporter {

    /**
     * @param {array} rows The array of rows.
     * @param {string} filename A url string for the exported csv file name.
     */
    static exportCSV(rows, filename) {
        let csv = "";
        rows.forEach(row => {
            // Escape each cell in the row
            const escapedRow = row.map(cell => this.escape(cell));
            csv += escapedRow.join(",") + "\n";
        });

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8," });

        const link = document.createElement("a");
        const csvUrl = URL.createObjectURL(blob);

        link.href = csvUrl;
        link.style = "visibility:hidden";
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    /**
     * @param {*} value
     * @returns Escaped values containing double quotes, commas, or newlines.
     */
    static escape(value) {
        let escapedValue;
        try {
            escapedValue = value.toString();
        } catch (error) {
            escapedValue = "";
        }

        /*
         * IMPORTANT: EXCEL HAS A HARD LIMIT OF 32,767 CHARACTERS PER CELL.
         *
         * CSV files themselves can contain larger values, but opening such a file in
         * Excel can cause oversized cells to be truncated or imported incorrectly.
         * Keep a small margin below Excel's limit so every CSV produced through this
         * shared exporter opens reliably. This truncation must happen before CSV quote
         * escaping because escaping can add characters to the serialized CSV without
         * adding characters to the value Excel ultimately places in the cell.
         */
        escapedValue = escapedValue.substring(0, 32000);

        // Escape double quotes by doubling them
        if (escapedValue.includes('"')) {
            escapedValue = escapedValue.replace(/"/g, '""');
        }

        // Escape values containing commas, double quotes, or newlines by wrapping them in double quotes
        if (escapedValue.includes(',') || escapedValue.includes('\n') || escapedValue.includes('"')) {
            escapedValue = `"${escapedValue}"`;
        }

        return escapedValue;
    }
}
